module.exports = __webpack_public_path__ + "static/media/icn_community_active.4f04d83d.svg";